import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";

import { privateRequest } from "../../commonApi/CommonApi";
import { Helmet } from "react-helmet";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function NewPackage() {
  const [combineData, setCombineData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [editorData, setEditorData] = useState("");
  const [value, setValue] = useState("");
  const [Name, setName] = useState("");
  const [packageType, setPackageType] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [ServiceStatus, setServiceStatus] = useState(1);
  const [selectedParentCategory, setSelectedParentCategory] = useState();
  const [SelectedChildCategory, setSelectedChildCategory] = useState("");
  const [selectedChildCategories, setSelectedChildCategories] = useState([]);
  const [additionalServices, setAdditionalServices] = useState([]);
  const [additionalAddOnServices, setAdditionalAddOnServices] = useState([]);
  const [childCategoryOptions, setChildCategoryOptions] = useState([]);
  const [ServiceGroupOptions, setServiceGroupOptions] = useState([]);
  const [selectedServiceGroups, setSelectedServiceGroups] = useState([]);
  const [ServiceTypeOptions, setServiceTypeOptions] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState();
  const [AddOnServiceOptions, setAddOnServiceOptions] = useState([]);
  const [regularPrice, setRegularPrice] = useState(0);
  const [salePrice, setSalePrice] = useState(0);
  const [payableAmount, setPayableAmount] = useState("");

  const [selectedAllVariantsPrice, setselectedAllVariantsPrice] = useState([]);
  const [discount, setDiscount] = useState("");
  const navigate = useNavigate();
  const [editorContent, setEditorContent] = useState("");
  const [isDiscription, setisDiscription] = useState(false);
  const [discounts, setDiscounts] = useState([]);

  useEffect(() => {
    if (
      additionalServices != undefined &&
      selectedAllVariantsPrice.length == 0
    ) {
      const initialVariants = additionalServices.map((service) => ({
        id: service.id || "",
        regulerPrice: service.regulerPrice || "",
        salePrice: service.salePrice || "",
      }));
      setselectedAllVariantsPrice(initialVariants);
    } else {
      let obj = {
        id: "",
        regulerPrice: "",
        salePrice: "",
      };
      selectedAllVariantsPrice.push(obj);
    }
  }, [additionalServices]);

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get("Service/CombineApis");
      setCombineData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };
  const getPackageDiscountData = async (e) => {
    try {
      const response = await privateRequest.get("PackageDiscount"); // + pc group Id lagani hai
      // setServiceOptions(response?.data.services);
      console.log("discount slab", response);
      setDiscounts(response.data.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const getDiscountPercentage = (totalSalePrice, discounts) => {
    let applicableDiscount = 0;
    for (const discount of discounts) {
      if (salePrice >= discount.MinValue) {
        applicableDiscount = parseInt(discount.DiscountApplied, 10);
      }
    }
    return applicableDiscount;
  };

  // Sort discounts by MinValue in ascending order
  discounts.length > 0 && discounts?.sort((a, b) => a.MinValue - b.MinValue);
  const discountPercentagee =
    getDiscountPercentage(salePrice, discounts || []) || 0;

  const discountAmount = Math.round((regularPrice * discountPercentagee) / 100);

  const calculateDiscountedPrice = () => {
    const discountPercentage = parseInt(discountPercentagee || "0", 10);
    const discountAmount = Math.round((salePrice * discountPercentage) / 100);
    return {
      discountAmount,
      discountedPrice: salePrice - discountAmount,
    };
  };

  let { discountedPrice } = calculateDiscountedPrice(salePrice, discountAmount);

  let totalSavedPrice = discountedPrice;

  // Function to get the next discount based on totalSalePrice
  const getNextDiscount = (totalSalePrice, discounts) => {
    for (const discount of discounts) {
      if (salePrice < discount.MinValue) {
        return discount;
      }
    }
    return null;
  };

  // Get the next discount
  const nextDiscount = getNextDiscount(salePrice, discounts);
  const moreServiceValueForDiscount = nextDiscount
    ? nextDiscount.MinValue - salePrice
    : 0;

  // Function to get the discount based on totalSavedPrice
  const getDiscountApplied = (totalSavedPrice, discounts) => {
    for (const discount of discounts) {
      if (totalSavedPrice >= discount.MinValue) {
        return discount.DiscountApplied;
      }
    }
    return null;
  };

  const discountApplied = getDiscountApplied(totalSavedPrice, discounts);

  useEffect(() => {
    getPackageDiscountData();
  }, []);

  const getAllServices = async (e) => {
    try {
      const response = await privateRequest.get(
        "Service/AllServicebyPGroup/" + e
      ); // + pc group Id lagani hai
      setServiceOptions(response?.data.services);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      formData.append("packageTitle", Name);
      if (selectedParentCategory) {
        formData.append("PcatId", selectedParentCategory);
      }
      formData.append("discription", editorData);
      formData.append("IsDiscription", isDiscription);
      formData.append("Status", ServiceStatus);
      formData.append("packageImage", selectedFile);
      formData.append("packageType", packageType);
      formData.append("RPrice", regularPrice);
      formData.append("SPrice", salePrice);
      formData.append("payble", payableAmount);
      formData.append("discount", discount);
      if (selectedGroup) {
        formData.append("PCgroup", selectedGroup);
      }

      selectedChildCategories.forEach((categoryId) => {
        formData.append("ChildId[]", categoryId);
      });

      selectedServiceGroups.forEach((groupId) => {
        formData.append("ServiceGroups[]", groupId);
      });

      selectedServices.forEach((serviceId, index) => {
        formData.append(`serviceId[${index}][service]`, serviceId?.service);
        formData.append(`serviceId[${index}][variant]`, serviceId?.variant?.id);
      });

      selectedAddons.forEach((addonServiceId, index) => {
        formData.append(
          `AddonService[${index}][service]`,
          addonServiceId?.service
        );
        formData.append(
          `AddonService[${index}][variant]`,
          addonServiceId?.variant
        );
      });

      const response = await privateRequest.post(
        "Package/AddPackage",
        formData
      );
      console.log("Service created successfully:", response.data);

      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Data added successfully!",
      });
      navigate("/package");
    } catch (error) {
      // setLoading(false);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: error.response.data.message,
      });
      console.error("Error creating service:", error);
    }
  };

  const handleParentCategoryChange = (selectedOption) => {
    setSelectedParentCategory(selectedOption?.value);
    setSelectedChildCategory("");
  };

  const handleChildCategoryChange = (selectedOptions) => {
    const selectedIds = selectedOptions.map((option) => option.value);
    setSelectedChildCategories(selectedIds);
    setSelectedChildCategory(selectedIds[0] || "");
  };

  useEffect(() => {
    getAllDocumentData();
  }, []);

  useEffect(() => {
    const childCategorySelectOptions = combineData?.childCategories
      ?.filter((category) => category.PCName[0] === selectedParentCategory)
      ?.map((category) => ({
        value: category._id,
        label: category.CCName,
      }));
    setChildCategoryOptions(childCategorySelectOptions || []);
  }, [selectedParentCategory, combineData?.childCategories]);

  useEffect(() => {
    const serviceGroupSelectOptions = combineData?.serviceGroups
      ?.filter((group) => group.PCName[0] === selectedParentCategory)
      ?.map((group) => ({
        value: group._id,
        label: group.GroupName,
      }));
    setServiceGroupOptions(serviceGroupSelectOptions || []);
  }, [selectedParentCategory, combineData?.serviceGroups]);

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleServiceChange = (index, selectedServiceId) => {
    const updatedServices = [...selectedServices];
    updatedServices[index] = {
      ...updatedServices[index],
      service: selectedServiceId,
      variant: null,
    };
    setSelectedServices(updatedServices);
  };

  const handleAddOnServiceChange = (index, selectedServiceId) => {
    const updatedServices = [...selectedAddons];
    updatedServices[index] = {
      ...updatedServices[index],
      service: selectedServiceId,
      variant: null, // Reset the variant when service changes
    };
    setSelectedAddons(updatedServices);
  };

  const handleVariantChange = (index, variantt) => {
    const updatedServices = [...selectedServices];
    updatedServices[index] = {
      ...updatedServices[index],

      variant: variantt,
    };

    setSelectedServices(updatedServices);
  };

  const handleVariantAddOnChange = (index, selectedVariantId) => {
    const updatedServices = [...selectedAddons];
    updatedServices[index] = {
      ...updatedServices[index],
      variant: selectedVariantId,
    };
    setSelectedAddons(updatedServices);
  };

  const handleAddService = () => {
    setSelectedServices([...selectedServices, {}]);
  };

  const handleAddAddonService = () => {
    setAdditionalAddOnServices([...additionalAddOnServices, {}]);
    setSelectedAddons([...selectedAddons, {}]);
  };

  const handleRemoveService = (id) => {
    const index = selectedServices?.findIndex(
      (service) => service.variant.id === id
    );

    if (index != -1) {
      const updatedSelectedaServices = [...selectedServices];

      updatedSelectedaServices.splice(index, 1);

      setSelectedServices(updatedSelectedaServices);
    } else {
      console.error("Service with ID", index, "not found.");
    }
  };

  const handleRemoveAdonService = (id, ind) => {
    const index = selectedAddons.findIndex(
      (service) => service.variant === ind
    );

    if (index != -1) {
      const updatedSelectedServices = [...selectedAddons];
      updatedSelectedServices.splice(index, 1);
      setSelectedAddons(updatedSelectedServices);
    } else {
      console.error("Service with ID", id, "not found.");
    }
  };

  const handleChangeServices = (selectedOptions) => {
    const selectedIds = selectedOptions.map((option) => option.value);
    setServiceTypeOptions(selectedIds);
  };

  const getVariantsForService = (serviceId) => {
    const selectedService = serviceOptions?.find(
      (option) => option._id === serviceId
    );
    return selectedService ? selectedService.ServiceVarients : [];
  };

  const handleGroupChange = (e) => {
    const selectedGroupId = e.target.value;
    setSelectedGroup(selectedGroupId);
    getAllServices(selectedGroupId);
  };

  const handleSelectedService = (e) => {
    handleServiceChange(0, e.value);
    handleChangeServices(selectedServices);
  };

  useEffect(() => {
    if (totalSavedPrice > 0 && packageType == "Editable") {
      handlePayableAmountChange(totalSavedPrice);
    }
  }, [totalSavedPrice]);

  useEffect(() => {
    let totalRegularPrice = 0;
    let totalSalePrice = 0;
    selectedServices?.forEach((item) => {
      totalRegularPrice += item?.variant?.regulerPrice
        ? parseInt(item?.variant?.regulerPrice)
        : 0;
      totalSalePrice += item?.variant?.saleePrice
        ? parseInt(item?.variant?.saleePrice)
        : 0;
      setRegularPrice(totalRegularPrice);
      setSalePrice(totalSalePrice);
    });
  }, [selectedServices]);

  const handlePayableAmountChange = (e) => {
    const enteredAmount =
      packageType == "Editable" ? e : parseFloat(e.target.value);
    if (!isNaN(enteredAmount) && enteredAmount !== 0 && regularPrice !== 0) {
      const discountPercentage = Math.round(
        ((regularPrice - enteredAmount) / regularPrice) * 100
      ); // Round to the nearest integer
      setPayableAmount(enteredAmount);
      setDiscount(discountPercentage);
    } else {
      setPayableAmount("");
      setDiscount("");
    }
  };

  const selectedServiceIds = (selectedServices || []).map(
    (service) => service.service
  );
  const selectedAddonids = (selectedAddons || []).map(
    (service) => service.service
  );

  // Step 2: Filter out the selected services from the service options
  let a = [...selectedServiceIds, ...selectedAddonids];

  const filteredServiceOptions = serviceOptions?.filter(
    (service) => !a.includes(service._id)
  );

  return (
    <>
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">New Package</span>
                    </p>
                    <Link
                      to="/package/"
                      className="btn btn-primary btn-sm ml-auto"
                      data-toggle="modal"
                      data-target="#childModal"
                    >
                      <i className="fa fa-plus mr-2"></i>All Packages
                    </Link>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Package Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Package Name"
                                value={Name}
                                onChange={(e) => setName(e.target.value)}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Parent Category</label>
                              <Select
                                isClearable
                                label={selectedParentCategory}
                                onChange={handleParentCategoryChange}
                                options={
                                  combineData?.parentCategories?.map(
                                    (category) => ({
                                      value: category._id,
                                      label: category.PCName,
                                    })
                                  ) || []
                                }
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Child Category</label>
                              <Select
                                isMulti
                                value={childCategoryOptions.filter((option) =>
                                  selectedChildCategories?.includes(
                                    option.value
                                  )
                                )}
                                onChange={handleChildCategoryChange}
                                options={childCategoryOptions}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Service Group</label>
                              <Select
                                isMulti
                                lable={selectedServiceGroups}
                                options={ServiceGroupOptions}
                                onChange={(selectedOptions) => {
                                  const selectedIds = selectedOptions.map(
                                    (option) => option.value
                                  );
                                  setSelectedServiceGroups(selectedIds);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Image</label>
                              <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={handleFileInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Package Type</label>
                              <select
                                className="form-control"
                                value={packageType}
                                onChange={(e) => setPackageType(e.target.value)}
                              >
                                <option value="">Select</option>
                                <option value="Normal">Normal</option>
                                <option value="Customize">Customize</option>
                                <option value="Editable">Editable</option>
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Status</label>
                              <select
                                className="form-control"
                                value={ServiceStatus}
                                onChange={(e) =>
                                  setServiceStatus(e.target.value)
                                }
                              >
                                <option value="">Select</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </select>
                            </div>
                          </div>
                          {imagePreview && (
                            <div className="col-lg-4">
                              <img
                                width="80"
                                height="50"
                                src={imagePreview}
                                alt="Preview"
                                style={{ maxWidth: "100%" }}
                              />
                            </div>
                          )}

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>
                                Parent Catagory Group For Services List
                              </label>
                              <select
                                className="form-control"
                                value={selectedGroup}
                                onChange={handleGroupChange}
                              >
                                <option>Select</option>
                                {combineData?.ParentGroup?.map(
                                  (item, index) => {
                                    return (
                                      <option key={item?._id} value={item?._id}>
                                        {item?.PCGName}
                                      </option>
                                    );
                                  }
                                )}
                              </select>
                            </div>
                          </div>
                          <div className="custom-control custom-control-inline custom-checkbox">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="ckb1"
                              name="spCommentShow"
                              checked={isDiscription == true ? true : false}
                              value="1"
                              onChange={(e) => {
                                setisDiscription(!isDiscription);
                              }}
                            />{" "}
                            <label
                              className="custom-control-label"
                              htmlFor="ckb1"
                            >
                              Is Description
                            </label>
                          </div>
                        </div>
                        <hr />

                        <div className="row">
                          <div className="col-lg-12">
                            <table className="table table-sm">
                              <thead className="bg-primary text-white">
                                <tr>
                                  <td colSpan={3}>Services</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr key={0}>
                                  <td style={{ width: "10%" }}>
                                    <button
                                      type="button"
                                      className="btn btn-primary btn-icon"
                                      onClick={handleAddService}
                                    >
                                      <i className="fa fa-plus"></i>
                                    </button>
                                  </td>
                                </tr>

                                {selectedServices?.map((service, index) => {
                                  let a = combineData?.newServiceId?.find(
                                    (item) => item?._id == service?.service
                                  );
                                  console.log("service", service);
                                  let values = {
                                    value: service.service || 0,
                                    label:
                                      a?.ServiceName +
                                      " - " +
                                      a?.ChildCatIDs?.CCName,
                                  };
                                  let sample = {
                                    label: "Select Service",
                                    value: "",
                                  };

                                  return (
                                    <tr key={index}>
                                      <td style={{ width: "50%" }}>
                                        <Select
                                          isClearable
                                          value={
                                            values.label ==
                                            "undefined - undefined"
                                              ? sample
                                              : values
                                          }
                                          onChange={(e) => {
                                            // if (e.length > 0) {
                                            handleServiceChange(index, e.value);
                                            // }
                                          }}
                                          options={
                                            packageType === "Customize"
                                              ? serviceOptions?.map(
                                                  (option) => ({
                                                    value: option._id,
                                                    label: `${
                                                      option.ServiceName
                                                    } - ${
                                                      option?.ChildCatIDs
                                                        ?.CCName || ""
                                                    }`,
                                                  })
                                                ) || []
                                              : filteredServiceOptions?.map(
                                                  (option) => ({
                                                    value: option._id,
                                                    label: `${
                                                      option.ServiceName
                                                    } - ${
                                                      option?.ChildCatIDs
                                                        ?.CCName || ""
                                                    }`,
                                                  })
                                                ) || [] // Fallback to an empty array if filteredServiceOptions is undefined
                                          }
                                        />
                                      </td>
                                      <td style={{ width: "50%" }}>
                                        <select
                                          value={service?.variant?.id}
                                          onChange={(e) => {
                                            let variantPrice =
                                              getVariantsForService(
                                                selectedServices[index]?.service
                                              ).find(
                                                (id) => id._id == e.target.value
                                              );

                                            let regulerPrice =
                                              variantPrice.VarientDiscription[0]
                                                ?.regularPrice;

                                            let saleePrice =
                                              variantPrice.VarientDiscription[0]
                                                ?.salePrice;

                                            let a = {
                                              regulerPrice,
                                              saleePrice,
                                              id: e.target.value,
                                            };
                                            handleVariantChange(index, a);
                                          }}
                                          className="form-control"
                                        >
                                          <option value={null}>
                                            Select Variant
                                          </option>

                                          {getVariantsForService(
                                            selectedServices[index]?.service
                                          )?.map((variant) => (
                                            <option
                                              key={variant._id}
                                              value={variant._id}
                                            >
                                              {variant?.ServiceType?.Name}
                                            </option>
                                          ))}
                                        </select>
                                      </td>
                                      <td style={{ width: "10%" }}>
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-icon"
                                          onClick={() => {
                                            // handleRemoveService(
                                            //   service?.variant.id
                                            // );
                                            const invalidVariant =
                                              selectedServices.some(
                                                (item) => !item.variant
                                              );
                                            if (invalidVariant) {
                                              Swal.fire({
                                                icon: "error",
                                                title: "Error!",
                                                text: "Please select a variant in this service before its remove",
                                              });
                                            } else {
                                              handleRemoveService(
                                                service?.variant.id
                                              );
                                            }
                                          }}
                                        >
                                          <i className="fa fa-minus"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>

                          {packageType != "Normal" && (
                            <div className="col-lg-12">
                              <table className="table table-sm">
                                <thead className="bg-primary text-white">
                                  <tr>
                                    <td colSpan={3}>Add on Services</td>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr key={0}>
                                    <td style={{ width: "10%" }}>
                                      <button
                                        type="button"
                                        className="btn btn-primary btn-icon"
                                        onClick={handleAddAddonService}
                                      >
                                        <i className="fa fa-plus"></i>
                                      </button>
                                    </td>
                                  </tr>

                                  {selectedAddons?.map((service, index) => {
                                    let a = combineData?.newServiceId?.find(
                                      (item) => item?._id == service?.service
                                    );

                                    let values = {
                                      value: service.service || 0,
                                      label:
                                        a?.ServiceName +
                                        " - " +
                                        a?.ChildCatIDs?.CCName,
                                    };
                                    let sample = {
                                      label: "Select Service",
                                      value: "",
                                    };
                                    return (
                                      <tr key={index}>
                                        <td style={{ width: "50%" }}>
                                          {/* <select
                                            onChange={(e) =>
                                              handleAddOnServiceChange(
                                                index,
                                                e.target.value
                                              )
                                            }
                                            className="form-control"
                                            value={service.service}
                                            options={filteredServiceOptions?.map(
                                              (option) => ({
                                                value: option._id,
                                                label:
                                                  option.ServiceName +
                                                  " - " +
                                                  option?.ChildCatIDs?.CCName,
                                              })
                                            )}
                                          >
                                            <option>Select Service</option>
                                            {filteredServiceOptions?.map(
                                              (option, index) => {
                                                return (
                                                  <option
                                                    key={option?._id}
                                                    value={option._id}
                                                  >
                                                    {option.ServiceName +
                                                      " - " +
                                                      option?.ChildCatIDs
                                                        ?.CCName}
                                                  </option>
                                                );
                                              }
                                            )}
                                          </select> */}

                                          <Select
                                            isClearable
                                            value={
                                              values.label ==
                                              "undefined - undefined"
                                                ? sample
                                                : values
                                            }
                                            onChange={(e) => {
                                              handleAddOnServiceChange(
                                                index,
                                                e.value
                                              );
                                            }}
                                            options={
                                              packageType === "Customize"
                                                ? serviceOptions?.map(
                                                    (option) => ({
                                                      value: option._id,
                                                      label: `${
                                                        option.ServiceName
                                                      } - ${
                                                        option?.ChildCatIDs
                                                          ?.CCName || ""
                                                      }`,
                                                    })
                                                  ) || []
                                                : filteredServiceOptions?.map(
                                                    (option) => ({
                                                      value: option._id,
                                                      label: `${
                                                        option.ServiceName
                                                      } - ${
                                                        option?.ChildCatIDs
                                                          ?.CCName || ""
                                                      }`,
                                                    })
                                                  ) || [] // Fallback to an empty array if filteredServiceOptions is undefined
                                            }
                                            // options={filteredServiceOptions?.map(
                                            //   (option) => ({
                                            //     value: option._id,
                                            //     label:
                                            //       option.ServiceName +
                                            //       " - " +
                                            //       option?.ChildCatIDs?.CCName,
                                            //   })
                                            // )}
                                          />
                                        </td>
                                        <td style={{ width: "50%" }}>
                                          <select
                                            value={service?.variant}
                                            onChange={(e) =>
                                              handleVariantAddOnChange(
                                                index,
                                                e.target.value
                                              )
                                            }
                                            className="form-control"
                                          >
                                            <option value={null}>
                                              Select Variant
                                            </option>

                                            {getVariantsForService(
                                              selectedAddons[index]?.service
                                            )?.map((variant) => (
                                              <option
                                                key={variant._id}
                                                value={variant._id}
                                              >
                                                {variant?.ServiceType?.Name}
                                              </option>
                                            ))}
                                          </select>
                                        </td>
                                        <td style={{ width: "10%" }}>
                                          <button
                                            type="button"
                                            className="btn btn-danger btn-icon"
                                            onClick={() => {
                                              {
                                                handleRemoveAdonService(
                                                  service.service,
                                                  service.variant
                                                );
                                              }
                                            }}
                                          >
                                            <i className="fa fa-minus"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          )}
                        </div>
                        <hr />
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Regular Price</label>
                              <input
                                readOnly
                                type="number"
                                className="form-control"
                                placeholder="Regular Price"
                                value={regularPrice}
                              />
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Sale Price</label>
                              <input
                                readOnly
                                type="number"
                                className="form-control"
                                placeholder="Sale Price"
                                value={salePrice}
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Payable Amount</label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Payable Amount"
                                value={
                                  packageType == "Editable"
                                    ? totalSavedPrice
                                    : payableAmount
                                }
                                onChange={handlePayableAmountChange}
                                readOnly={
                                  packageType == "Editable" ? true : false
                                }
                              />
                            </div>
                          </div>

                          <div className="col-lg-3">
                            <div className="form-group">
                              <label>Discount</label>
                              <input
                                type="number"
                                className="form-control"
                                placeholder="Discount"
                                value={discount}
                                onChange={(e) => {
                                  let a = parseInt(e.target.value);
                                  setDiscount(a);
                                }}
                                readOnly={packageType !== "Editable"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12">
                            <div className="form-group" id="allDiscription">
                              <label>Description</label>

                              <ReactQuill
                                className="h-100"
                                modules={{
                                  toolbar: [
                                    [{ header: [1, 2, false] }],
                                    [
                                      "bold",
                                      "italic",
                                      "underline",
                                      "strike",
                                      "blockquote",
                                    ],
                                    [
                                      { list: "ordered" },
                                      { list: "bullet" },
                                      { indent: "-1" },
                                      { indent: "+1" },
                                    ],
                                    ["link", "image"],
                                    ["clean"],
                                  ],
                                }}
                                theme="snow"
                                formats={[
                                  "header",
                                  "bold",
                                  "italic",
                                  "underline",
                                  "strike",
                                  "blockquote",
                                  "list",
                                  "bullet",
                                  "indent",
                                  "link",
                                  "image",
                                ]}
                                value={value}
                                onChange={setValue}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-12">
                            <button type="submit" className="btn btn-primary">
                              Create Package
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NewPackage;
